import {addServerSurvey} from '@/api/diagnoses'

const app = {
    state: {},
    mutations: {},
    actions: {
        AddServerSurvey({commit}, data) {
            return new Promise((resolve, reject) => {
                addServerSurvey(data).then(response =>{
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}
export default app


// WEBPACK FOOTER //
// ./src/store/modules/diagnoses.js